// Default configuration
const defaultConfig = {
  network: process.env.REACT_APP_NETWORK || 'testnet',
  enableNetworkSwitch: process.env.REACT_APP_ENABLE_NETWORK_SWITCH === 'true',
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3004',
  roadrunnerApiUrl: process.env.REACT_APP_ROADRUNNER_API_URL || 'http://localhost:3001',
  pinDataUrl: process.env.REACT_APP_API_BASE_URL || '/api/pins',
  ethereumRpcUrl: 'https://assurety-chain.paystand.com:8541/',
  notaryVerificationPath: process.env.REACT_APP_NOTARY_VERIFICATION_PATH || '/notary-verification/index.html',
  defaultApiEndpoint: process.env.REACT_APP_DEFAULT_API_ENDPOINT || 'http://localhost:3004',
  explorerUrls: {
    bitcoin: {
      testnet: process.env.REACT_APP_BITCOIN_TESTNET_EXPLORER || 'https://blockstream.info/testnet/tx',
      mainnet: process.env.REACT_APP_BITCOIN_MAINNET_EXPLORER || 'https://blockstream.info/tx'
    },
    ethereum: {
      testnet: process.env.REACT_APP_ETHEREUM_TESTNET_EXPLORER || 'https://sepolia.etherscan.io/tx',
      mainnet: process.env.REACT_APP_ETHEREUM_MAINNET_EXPLORER || 'https://etherscan.io/tx'
    }
  }
};

// Configuration state
let currentConfig = { ...defaultConfig };
let isLoaded = false;

// Load configuration from config.json
export const loadConfig = async () => {
  try {
    const response = await fetch('/config.json');
    if (!response.ok) {
      console.warn('Configuration file not found, using defaults');
      isLoaded = true;
      return currentConfig;
    }
    const config = await response.json();
    
    // Merge configs but ensure we still have default values for missing properties
    currentConfig = {
      ...defaultConfig,
      ...config,
      // Ensure these critical properties have defaults if missing in config.json
      pinDataUrl: config.pinDataUrl || defaultConfig.pinDataUrl,
      ethereumRpcUrl: config.ethereumRpcUrl || defaultConfig.ethereumRpcUrl,
      notaryVerificationPath: config.notaryVerificationPath || defaultConfig.notaryVerificationPath,
      defaultApiEndpoint: config.defaultApiEndpoint || defaultConfig.defaultApiEndpoint,
      explorerUrls: {
        bitcoin: {
          testnet: config.explorerUrls?.bitcoin?.testnet || defaultConfig.explorerUrls.bitcoin.testnet,
          mainnet: config.explorerUrls?.bitcoin?.mainnet || defaultConfig.explorerUrls.bitcoin.mainnet
        },
        ethereum: {
          testnet: config.explorerUrls?.ethereum?.testnet || defaultConfig.explorerUrls.ethereum.testnet,
          mainnet: config.explorerUrls?.ethereum?.mainnet || defaultConfig.explorerUrls.ethereum.mainnet
        }
      }
    };
    
    console.log('Configuration loaded successfully');
    isLoaded = true;
    return currentConfig;
  } catch (error) {
    console.warn('Failed to load configuration, using defaults:', error);
    isLoaded = true;
    return currentConfig;
  }
};

// Check if configuration is loaded
export const isConfigLoaded = () => isLoaded;

// Export configuration getters
export const getNetwork = () => currentConfig.network;
export const getExplorerUrls = () => currentConfig.explorerUrls;
export const getApiBaseUrl = () => currentConfig.apiBaseUrl;
export const getRoadrunnerApiUrl = () => currentConfig.roadrunnerApiUrl;
export const getPinDataUrl = () => currentConfig.pinDataUrl;
export const getEthereumRpcUrl = () => currentConfig.ethereumRpcUrl;
export const getNotaryVerificationPath = () => currentConfig.notaryVerificationPath;
export const getDefaultApiEndpoint = () => currentConfig.defaultApiEndpoint;
export const getFeatures = () => ({
  enableNetworkSwitch: currentConfig.enableNetworkSwitch
});

// Export the entire configuration object
export default currentConfig; 